import { Theme, createStyles } from "@material-ui/core";

export const styles = ({ palette, spacing }: Theme) => createStyles({

    container: {
        backgroundColor: palette.primary.light,
        padding: spacing.unit * 3,
        position: "relative"
    },
    list: {
        maxWidth: spacing.unit * 90
    },
    button: {
        position: "absolute",
        right: spacing.unit * 3,
        bottom: spacing.unit * 3,
        textTransform: "initial"
    },
    buttonLabel: {
        marginLeft: spacing.unit
    }
});


// WEBPACK FOOTER //
// ./src/components/CustomerInformations/CustomerInformations.style.tsx